import React, { memo } from 'react';
import classnames from 'classnames/bind';
import styles from "../../styles.pcss";
var cn = classnames.bind(styles);
export var FilesInput = /*#__PURE__*/memo(function (_ref) {
  var id = _ref.id,
    allowedTypes = _ref.allowedTypes,
    handleChange = _ref.handleChange,
    multiple = _ref.multiple;
  var allowedText = ".".concat(allowedTypes.join(', .'));
  return /*#__PURE__*/React.createElement("input", {
    accept: allowedText,
    className: cn('input'),
    id: id,
    multiple: multiple,
    onChange: handleChange,
    type: "file",
    "data-t-id": "components-FilesInput"
  });
});